<template>
  <div class="page-main" id="index">
    <el-container>
      <el-aside width="240px" style="background: #1d2226">
        <div class="logo flex center alcenter">
          <h1 style="color: #fff; font-size: 18px">路小卫智能管理系统</h1>
        </div>
        <el-menu
          :default-active="meauActive"
          class="el-menu-vertical-demo"
          text-color="#c1c1c1"
          :unique-opened="true"
        >
          <blockquote v-for="(item, k) in menus" :key="item.id">
            <div v-if="item.childmenu">
              <el-submenu :index="'' + (k + 1) + ''">
                <template slot="title">
                  <i :class="'' + item.icon + ''"></i>
                  <span slot="title">{{ item.name }}</span>
                </template>
                <!-- <el-menu-item-group> -->
                <el-menu-item
                  :index="'' + (k + 1) + '-' + (j + 1) + ''"
                  style="padding-left: 29px; background: #0f1112"
                  v-for="(v, j) in item.childmenu"
                  :key="v.id"
                  @click="toPth(v.url, '' + (k + 1) + '-' + (j + 1) + '')"
                >
                  {{
                  v.name
                  }}
                </el-menu-item>
                <!-- </el-menu-item-group> -->
              </el-submenu>
            </div>
            <div v-else>
              <el-menu-item :index="'' + (k + 1) + ''" @click="toPth(item.url, '' + (k + 1) + '')">
                <i :class="'' + item.icon + ''"></i>
                <span slot="title">{{ item.name }}</span>
              </el-menu-item>
            </div>
          </blockquote>
        </el-menu>
      </el-aside>
      <el-main>
        <!--头部-->
        <el-col class="main_haed">
          <el-dropdown trigger="hover" class="el-dropdown-admin">
            <span class="el-dropdown-link userinfo-inner">
              <!--<img src="../../static/img/index/header.png" class="hader"/>-->
              {{ adminName }}
              <i class="el-icon-caret-bottom"></i>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-button type="text" @click="editpwd">修改密码</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <span @click="logout">退出登录</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-col>
        <section class="content-container">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item v-if="oneMenuName">
              {{
              oneMenuName
              }}
            </el-breadcrumb-item>
            <el-breadcrumb-item v-if="twoMenuName">
              {{
              twoMenuName
              }}
            </el-breadcrumb-item>
            <el-breadcrumb-item v-if="threeMenuName">
              {{
              threeMenuName
              }}
            </el-breadcrumb-item>
          </el-breadcrumb>
          <router-view v-slot="{ Component }">
            <keep-alive>
              <component :is="Component" />
            </keep-alive>
          </router-view>
        </section>
      </el-main>
    </el-container>
  </div>
</template>


<script>
//import { menus } from "../router/menus";

export default {
  data() {
    return {
      meauActive: "1-1",
      isCollapse: false,
      oneMenuName: "",
      twoMenuName: "",
      threeMenuName: "",
      adminName: "",
      menus: [],
    };
  },
  mounted: function () {
    this.getList();
    this.meauActive = sessionStorage.getItem("meauActive");
  },
  methods: {
    getList() {
      let that = this;
      that.axios.post("/userinfo/info").then((res) => {
        if (res) {
          that.adminName = res.data.username;
          that.menus = res.data.menu;
        }
      });
    },

    logout() {
      this.$confirm("此操作将登出后台, 是否继续?", "温馨提示", {
        confirmButtonText: "登出",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          sessionStorage.removeItem("access-token");
          this.$message({
            type: "success",
            message: "退出成功!",
          });
          this.$router.push("/Login");
        })
        .catch(() => {});
    },
    editpwd() {
      this.$router.push("/Config/password");
    },
    toPth(path, active) {
      sessionStorage.setItem("meauActive", active);
      this.$router.push(path);
    },
  },
};
</script>
<style>
.el-menu {
  border: none;
}

#index .el-dropdown-admin {
  position: fixed;
  right: 40px;
  z-index: 999;
}

@import "../../public/css/index.css";
</style>